import React from 'react';
import ActionElement from './_ActionElementController';

const Button = React.forwardRef((props, ref) => <ActionElement ref={ref} type='button' {...props} />);
const Link = React.forwardRef((props, ref) => <ActionElement ref={ref} type='link' {...props} />);

export * from './_allowedPropTypes';
export { ActionElement, Button, Link };